import { Select, IProps as SelectProps } from 'components/atoms/Select/Select.components';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

interface TechnologySelectProps extends Omit<SelectProps, 'handleChange'> {
  handleChange: (value: { value: string; externalCode: string }) => void;
  chapter: { externalName: string; externalCode: string }[];
  isLoading: boolean;
}

export default function TechnologySelect({ idPosition, chapter, isLoading, handleChange, ...rest }: Readonly<TechnologySelectProps>) {

  const { setValue, getValues } = useFormContext();

  const options = chapter?.map(({ externalName }) => ({
    value: externalName,
    label: externalName,
  }));

  useEffect(() => {
    const currentValue = getValues(`growInformation.${idPosition}.technology`);
    if (chapter && currentValue) {
      const selectedChapter = chapter.find(({ externalName }) => externalName === currentValue);
      if (selectedChapter) {
        setValue(`growInformation.${idPosition}.idTechnologySap`, selectedChapter.externalCode);
        setValue(`growInformation.${idPosition}.technology`, currentValue);
      } else {
        setValue(`growInformation.${idPosition}.idTechnologySap`, undefined);
        setValue(`growInformation.${idPosition}.technology`, undefined);
      }
    }
  }, [chapter, getValues, setValue]);

  return (
    <Select
      handleChange={(value) =>
        handleChange({
          value: value?.toString() ?? '',
          externalCode: chapter?.find(({ externalName }) => externalName === value)?.externalCode ?? ''
        })
      }
      disabled={isLoading}
      options={options}
      {...rest}
    />
  );
}
